<template>
    <div class="qksm qksm8">
        <div class="nogap">
            <p><b>（三）机关运行经费情况</b></p>
            <p class="hide_pdf">
                （选择单位性质<reason type="select" classname="qksm select " name="单位性质" v-model:value="qksm['单位性质']" optionarr="请选择,行政或参公单位,事业单位"></reason>）<br />
            </p>
            <p>
                <template v-if="qksm['单位性质']=='事业单位'">
                    机关运行经费是指用于维持行政及参照公务员法管理单位机关运行的经费，{{$store.state.divData.divname}}及所属单位均为事业单位，无机关运行经费。2021年{{$store.state.divData.divname}}及所属单位的事业运行经费财政拨款预算为
                    <reason type="money" classname="qksm money" name="T8事业机关" v-model:value="T8['事业机关']"></reason>万元。
                    <span class="hide_pdf">
                        （去年预算数<reason type="money" classname="qksm money editLast" name="T8事业机关last" v-model:value="qksm['T8事业机关last']"></reason>万元）
                    </span>
                    <span v-if="num(T8['事业机关']).toFixed(2)==num(qksm['T8事业机关last']).toFixed(2)">
                        与2020年预算数相同。
                    </span>
                    <span v-else>
                        较2020年预算{{growthValueText(T8['事业机关'],qksm['T8事业机关last'])}}万元
                        <span v-if="num(qksm['T8事业机关last'])==0">
                            （去年预算数为0万元，无法计算增减比率）。
                        </span>
                        <span v-else>
                            ，{{growthRatioText(T8['事业机关'],qksm['T8事业机关last'])}}。
                        </span>
                        主要原因是<reason type="textarea" classname="qksm widest because" name="T8事业机关原因" v-model:value="qksm['T8事业机关原因']" ></reason>
                    </span>
                </template>
                <template v-else>
                    2021年
                    <reason type="textarea" classname="qksm" name="T8单位名称" v-model:value="qksm['T8单位名称']" v-if="num(qksm['T8单位数量1'])>0"></reason>
                    <template v-if="num(qksm['T8单位数量1']) > 1">
                        、
                        <reason type="textarea" classname="qksm" name="T8单位1" v-model:value="qksm['T8单位1']"></reason>等
                    </template>
                    <reason type="integer" classname="qksm integer must" name="T8单位数量1" v-model:value="qksm['T8单位数量1']"></reason>家行政单位以及
                    <template v-if="num(qksm['T8单位数量2']) > 0 ">
                        <reason type="textarea" classname="qksm" name="T8单位2" v-model:value="qksm['T8单位2']"></reason>等
                    </template>
                    <reason type="integer" classname="qksm integer must" name="T8单位数量2" v-model:value="qksm['T8单位数量2']"></reason>家参公管理事业单位的机关运行经费财政拨款预算为
                    <reason type="money" classname="qksm money" name="T8机关" v-model:value="T8['机关']"></reason>万元。
                    <span class="hide_pdf">
                        （去年预算数<reason type="money" classname="qksm money editLast" name="T8机关last" v-model:value="qksm['T8机关last']"></reason>万元）
                    </span>
                    <span v-if="num(T8['机关']).toFixed(2)==num(qksm['T8机关last']).toFixed(2)">
                        与2020年预算数相同。
                    </span>
                    <span v-else>
                        较2020年预算{{growthValueText(T8['机关'],qksm['T8机关last'])}}万元
                        <span v-if="num(qksm['T8机关last'])==0">
                            （去年预算数为0万元，无法计算增减比率）。
                        </span>
                        <span v-else>
                            ，{{growthRatioText(T8['机关'],qksm['T8机关last'])}}。
                        </span>
                        <span class="hide_pdf">
                            <br />
                            <span class="red">主要原因是：办公设施设备购置经费增加（减少）/资产运行维护支出增加（减少）/信息系统运行维护支出增加（减少）/人员编制数量增加（减少）/编制内实有人数增加（减少）/……等（具体增减原因根据本部门实际情况填列）</span>
                            <br />
                        </span>
                        主要原因是<reason type="textarea" classname="qksm widest because" name="T8原因" v-model:value="qksm['T8原因']" placeholder="办公设施设备购置经费增加（减少）/资产运行维护支出增加（减少）/信息系统运行维护支出增加（减少）/人员编制数量增加（减少）/编制内实有人数增加（减少）/……等"></reason>
                    </span>
                </template>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm8",
        components: {
            reason,
        },
        props: {
            T8: {
                type: Object,
                default: "",
            },
        },
        data() {
            var qksm = this.$store.state.divData.qksm
            if (qksm['T8机关'])
                this.T8['机关'] = qksm['T8机关'];
            if (qksm['T8事业机关'])
                this.T8['事业机关'] = qksm['T8事业机关'];
            qksm['T8单位数量1'] = this.pickOneOf(qksm['T8单位数量1'], 1)
            if (!qksm['T8单位名称']) {
                qksm['T8单位名称'] = this.$store.state.divData.divname
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
    };
</script>